var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFfphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.79 0 0 0.79 250 244.68)",
    id: "QAABIYDDTNg9_2cfaDyt_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.34 0 0 0.34 -5.16 -3.34)",
    id: "yLUGj0d-TLYPHa432EuLD"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeOpacity: 0,
      strokeWidth: 2.94,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      fill: "rgb(132,24,38)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-1242.97, -1766.06)",
    d: "M 1572.11 1952.62 L 1938.38 2134.28 C 1938.38 2134.28 1969.4 2499.08 1567.67 2459.21 C 1244.9 2427.17 909.885 2087.15 789.912 1937.9 C 760.569 1901.39 744.09 1876.3 743.799 1869.91 C 742.322 1837.42 526.444 1660.19 548.598 1282.1 C 548.598 1282.1 637.213 983.761 880.905 1094.53 L 1049.28 1451.94 C 934.654 1497 898.049 1539.32 854.321 1615.88 C 854.321 1615.88 981.336 1958.53 1403.74 2138.72 L 1572.11 1952.62 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.34 0 0 0.34 -177.54 27.33)",
    id: "H2EIY4E2AyQ4wnLNbZwJh"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(132,24,38)",
      strokeOpacity: 0,
      strokeWidth: 2.94,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      fill: "rgb(132,24,38)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-1035.36, -1041.16)",
    d: "M 1088.62 1122.9 C 1088.62 1122.9 1014.28 1017.99 986.233 971.98 C 958.187 925.967 1081.72 1021.27 1081.72 1021.27 L 1088.62 1122.9 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.34 0 0 0.34 -179.35 23.67)",
    id: "D8WYYzUuUlCkBxYnfkPY7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(132,24,38)",
      strokeOpacity: 0,
      strokeWidth: 2.94,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      fill: "none",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-1030.04, -1030.4)",
    d: "M 963.351 937.463 L 1096.73 964.989 L 1091.69 1123.34",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfphone);
export default __webpack_public_path__ + "static/media/ffphone.849e5ff54bff73ece00a6076ffdd1ce2.svg";
export { ForwardRef as ReactComponent };